export default __webpack_public_path__ + "static/media/45_mobile.fd97d4ee.jpg";